import axios from 'axios'

export default {
    getAll: () => axios.get(`/user`),
    getById: id => axios.get(`/user/${id}`),
    create: formData => axios.post(`user/create`, formData),
    edit: formData => axios.put(`user/edit`, formData),
    changeStatus: formData => axios.patch(`user/toggle_status`, formData),
    delete: id => axios.delete(`/user/${id}`)
}